module.exports = __webpack_public_path__ + "static/media/Sakura-Regular.e8ece641.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Sakura-Regular.otf
// module id = 1480
// module chunks = 44